import { render } from "./postitus.vue?vue&type=template&id=57bb5c57"
import script from "./postitus.vue?vue&type=script&lang=js"
export * from "./postitus.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__